import React from 'react';
import { Path } from 'react-native-svg';
import SVGIcon from './SVGIcon';
import withDefaultIconProps from './withDefaultIconProps';
const EditIcon = ({ color, ...rest }) => {
    return (React.createElement(SVGIcon, { viewBox: "-1 -1 26 26", ...rest },
        React.createElement(Path, { d: "M3.5 17.25V21h3.75L18.31 9.94l-3.75-3.75L3.5 17.25zM21.21 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z", fill: color })));
};
export default withDefaultIconProps(EditIcon);
